<template>
  <div class="pt-6 im:pt-8 pb-30 im:pb-8 bg-grey-100" ref="container">
    <div class="px-4">
      <div class="font-semibold text-xl heading-5 mb-1">
        <template v-if="enabledFilters.length === 0">
          Available venues you might like
        </template>
        <template v-else>
          These venues match most of your filters
        </template>
      </div>

      <div class="flex flex-col justify-between im:flex-row text-sm">
        <div class="mb-1.5 im:mb-0">
          Missing:

          <div v-for="(filter, index) in disabledFilters" :key="index" class="inline">
            <span class="line-through">
              {{ filter.label }}
            </span><template v-if="index !== disabledFilters.length - 1">
              &nbsp;·
            </template>
          </div>
        </div>
        <div class="whitespace-nowrap">
          <span class="font-semibold">{{ store.state.roomsReducedFilters.length }}</span> similar results
        </div>
      </div>
    </div>

    <div class="mt-4 im:mt-7 v-search-results-items">
      <RoomCard
        v-for="(room, i) in store.state.roomsReducedFilters"
        :room="room"
        :key="getRoomKey(room, i)"
        :index="i"
        :manager-last-activity-online="store.state.managersLastActivityOnline[room.venue_id]"
        :search-event-category="store.state.eventCategory"
        @trackClick="roomCardClick(room)"
        @mouseOut="roomCardMouseOut(room)"
        @mouseOver="roomCardMouseOver(room)"
      />

      <div
        v-for="i in 3"
        :key="i"
        class="c-room-card c-room-card--empty v-room-carousel--empty"
      />
    </div>
  </div>
</template>

<script setup>
import { useIntersectionObserver } from '@vueuse/core';
import { onMounted, onUnmounted, ref, useTemplateRef } from 'vue';
import { useStore } from 'vuex';

import RoomCard from '@/modules/public/search/components/RoomCard.vue';

const emit = defineEmits(['roomCardMouseOut', 'roomCardMouseOver']);

const store = useStore();

const intersectionObserver = ref(null);
const container = useTemplateRef('container');

const filters = store.getters.getSearchLabelledFiltersList;
const disabledFilters = filters.filter((filter) => filter.disabled);
const enabledFilters = filters.filter((filter) => !filter.disabled);

const getRoomKey = (room, index) => {
  return `reduced-filters-rooms-${room.room_id}-${index}`;
};

const roomCardClick = (room) => {
  App.track.event('search_page_interaction', {
    section: 'additional_list',
    element: 'room',
    element_value: room.id,
    interaction: 'click',
  });
};
const roomCardMouseOut = (room) => {
  emit('roomCardMouseOut', room);
};
const roomCardMouseOver = (room) => {
  emit('roomCardMouseOver', room);
};

onMounted(() => {
  intersectionObserver.value = useIntersectionObserver(container, ([entry]) => {
    if (entry.isIntersecting) {
      App.track.event('search_page_interaction', {
        section: 'additional_list',
        element: 'section',
        element_value: disabledFilters.map((filter) => filter.label),
        interaction: 'visible',
      });

      intersectionObserver.value.stop();
    }
  });
});

onUnmounted(() => {
  if (intersectionObserver.value) {
    intersectionObserver.value.stop();
  }
});
</script>
